import React from "react";
import classNames from "classnames";
import CustomInput from "src/app/components/CustomInput/CustomInput";
import { ReactComponent as ChevronUpIcon } from "src/images/chevron-up-grey.svg";
import { ReactComponent as ChevronDownIcon } from "src/images/chevron-down.svg";
import { ReactComponent as CloseIcon } from "src/images/close.svg";
import { UseTableSearchReturn } from "./useTableSearch";

import "./TableSearchBar.scss";

interface TableSearchBarProps {
  search: UseTableSearchReturn;
}

export function TableSearchBar({ search }: TableSearchBarProps) {
  const {
    showSearch,
    inputValue,
    searchValue,
    searchResults,
    highlightedCellIndex,
    inputRef,
    setInputValue,
    close,
    goToNext,
    goToPrev,
  } = search;

  const resultsCount = searchResults.length;
  const hasResults = resultsCount > 0;

  const renderCounter = () => {
    if (searchValue.length > 0) {
      if (hasResults) {
        return `${highlightedCellIndex + 1} of ${resultsCount} results`;
      }
      return `${resultsCount} results`;
    }
    return "Type to search";
  };

  return (
    <div className="table-search-bar__wrapper">
      <div
        className={classNames("table-search-bar", {
          "table-search-bar--hidden": !showSearch,
        })}
      >
        <div className="table-search-bar__input-wrapper">
          <CustomInput
            ref={inputRef}
            value={inputValue}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setInputValue(e.target.value)
            }
          />
          <span className="table-search-bar__buttons">
            <button
              className={classNames("table-search-bar__buttons-item", {
                "table-search-bar__buttons-item--disabled": !hasResults,
              })}
              onClick={goToPrev}
            >
              <ChevronUpIcon />
            </button>
            <button
              className={classNames("table-search-bar__buttons-item", {
                "table-search-bar__buttons-item--disabled": !hasResults,
              })}
              onClick={goToNext}
            >
              <ChevronDownIcon />
            </button>
            <button className="table-search-bar__buttons-item" onClick={close}>
              <CloseIcon />
            </button>
          </span>
        </div>
        <span className="table-search-bar__text">{renderCounter()}</span>
      </div>
    </div>
  );
}
